export default class Locale_MatchingActivityDialog { 
	FailedCreatingMatchingActivity: string = 'Failed creating matching activity';
	CreateMatchingActivity: string = 'Create matching [[matchtype]]';
}